/* empty css                       */
import "./style/index.scss.js";
import t from "./core/core.js";
import { PayoutElement as m } from "./components/external/PayoutDetails/PayoutDetails.js";
import { PayoutsElement as f } from "./components/external/PayoutsOverview/PayoutsOverviewElement.js";
import { TransactionElement as c } from "./components/external/TransactionDetails/TransactionDetails.js";
import { TransactionsElement as E } from "./components/external/TransactionsOverview/TransactionsOverviewElement.js";
import { CapitalOfferElement as O } from "./components/external/CapitalOffer/CapitalOfferElement.js";
import { ReportsElement as u } from "./components/external/ReportsOverview/ReportsOverviewElement.js";
import { CapitalOverviewElement as C } from "./components/external/CapitalOverview/CapitalOverviewElement.js";
import { all_locales as T, da_DK as D, de_DE as R, en_US as d, es_ES as S, fi_FI as F, fr_FR as I, it_IT as N, nl_NL as z, no_NO as A, pt_BR as B, sv_SE as K } from "./translations/index.js";
async function n(e) {
  return await new t(e).initialize();
}
export {
  n as AdyenPlatformExperience,
  O as CapitalOffer,
  C as CapitalOverview,
  t as Core,
  m as PayoutDetails,
  f as PayoutsOverview,
  u as ReportsOverview,
  c as TransactionDetails,
  E as TransactionsOverview,
  T as all_locales,
  D as da_DK,
  R as de_DE,
  d as en_US,
  S as es_ES,
  F as fi_FI,
  I as fr_FR,
  N as it_IT,
  z as nl_NL,
  A as no_NO,
  B as pt_BR,
  K as sv_SE
};
